import { Component, OnInit, ViewChild } from '@angular/core';
import { SrubUpService } from '../Services/ScrubUp.service';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
 import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs';
 import {MatSort,Sort,MatTableModule,MatSortModule} from '@angular/material';
import {LiveAnnouncer} from '@angular/cdk/a11y';


interface USERROLE {
  RoleName:string;
  RoleCategory: string;
  IOSCount: string;
  AndroidCount:string
}

@Component({
  selector: 'app-specialities-report',
  templateUrl: './specialities-report.component.html',
  styleUrls: ['./specialities-report.component.scss'],
  providers: [SrubUpService],
})
export class SpecialitiesReportComponent implements OnInit {
  displayedColumns: string[] = ['Name','PublicCount','PrivateCount','OthersCount','TotalDownloads'];
  dataSource: eDataSource;
  ELEMENT_DATA: USERROLE[] =[];
  row:any=[];
  showMyContainerflag:boolean=false;
  public loading = false;
  data:any=[];
  selectedRowIndex:any;
  loginUserId: number;
  specialityHeading:any;
  @ViewChild(MatSort)sort!: MatSort;
  constructor(private _liveAnnouncer: LiveAnnouncer, private scrubUpService: SrubUpService,private cookieService: CookieService, private appUser: AppWideUser, private token: Token) { 
    if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {

      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
            this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
            this.token = JSON.parse(this.cookieService.get('Token'));
        }
         this.loginUserId = this.appUser.UserId;
  }

  ngOnInit() {
    this.getSpecialityReport();
  }
  highlight(row){
    //console.log(row);
    this.selectedRowIndex = row.Name;
  }

  getSpecialityReport() {
    this.loading = true;
    this.data=[];
    this.scrubUpService.GetSpecialityReport(this.token).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        this.data = x['Data'];

        // for(var i=0;i<x['Data'].length;i++)
        // {
        //   if( x['Data'][i].TotalDownloads>0)
        //   {
        //  this.data.push( x['Data'][i]);
        //   }
        // }


        this.dataSource = new eDataSource(this.data);
        
        //console.log(this.data);
      }
      this.loading = false;
     
    },
      error => {
        this.loading = false;
      })
  }

  showMyContainer(row)
  { 
    this.row=[];

  this.specialityHeading = row.Name;
    // if(this.showMyContainerflag==false)
    // {
      this.row = row['Roles'];
    //  console.log(this.row.length);
      this.showMyContainerflag=true;
    // }
    // else{
    //   this.showMyContainerflag=false;
    // }
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction =='asc') {
      // this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
      
       this.data.sort((a, b) => a[sortState.active] > b[sortState.active] ? 1 : a[sortState.active] < b[sortState.active] ? -1 : 0);
       //console.log( this.data);
       return this.dataSource = new eDataSource(this.data);
     } else {
      // this._liveAnnouncer.announce('Sorting cleared');
       this.data.sort((a, b) => a[sortState.active] < b[sortState.active] ? 1 : a[sortState.active] > b[sortState.active] ? -1 : 0);
       //console.log( this.data);
       return this.dataSource = new eDataSource(this.data);
     }
  }
}

export class eDataSource extends DataSource<any> {

  constructor(private element: Element[]) {
    super();
  }

  connect(): Observable<Element[]> {
    return Observable.of(this.element);
  }

  disconnect() {}
  
}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/specialities-report/specialities-report.component.ts